<template>
    <div class="login weflix">
        <div class="content">
            <div class="logo">
                <img alt="Tutor" src="@/assets/logo-tutor.png" style="width: 200px" />
            </div>
            <div class="info">
                <div class="form">
                    <form @submit.prevent="handleSubmit" class="form">
                        <div class="success" v-if="success">
                            <p class="success-title">Conta ativada com sucesso.</p>
                            <p class="success-text">Você será redirecionado para o login.</p>
                        </div>

                        <template v-else>
                        <h4 class="form-title">Definir senha</h4>
                        <p class="form-subtitle">Crie a senha de acesso do super admin.</p>

                        <div class="mb-3 password">
                            <label for="password" class="form-label">Nova senha</label>
                            <div class="password-control">
                                <input
                                    id="password"
                                    v-model="password"
                                    :type="showPassword"
                                    class="form-control"
                                    required
                                    minlength="8"
                                    :disabled="isLoading || success"
                                    placeholder="Mínimo de 8 caracteres"
                                    @input="validatePassword"
                                />
                                <button
                                    type="button"
                                    class="password-toggle"
                                    aria-label="Mostrar ou ocultar senha"
                                    @click="showPassword = showPassword === 'password' ? 'text' : 'password'"
                                >
                                    <fa :icon="showPassword === 'password' ? 'eye-slash' : 'eye'" />
                                </button>
                            </div>
                            <small class="field-error" v-if="passwordError">{{ passwordError }}</small>
                        </div>

                        <div class="mb-3 password">
                            <label for="confirmPassword" class="form-label">Confirmar senha</label>
                            <div class="password-control">
                                <input
                                    id="confirmPassword"
                                    v-model="confirmPassword"
                                    :type="showConfirmPassword"
                                    class="form-control"
                                    required
                                    minlength="8"
                                    :disabled="isLoading || success"
                                    placeholder="Repita a nova senha"
                                    @input="validateConfirmPassword"
                                />
                                <button
                                    type="button"
                                    class="password-toggle"
                                    aria-label="Mostrar ou ocultar confirmação de senha"
                                    @click="showConfirmPassword = showConfirmPassword === 'password' ? 'text' : 'password'"
                                >
                                    <fa :icon="showConfirmPassword === 'password' ? 'eye-slash' : 'eye'" />
                                </button>
                            </div>
                            <small class="field-error" v-if="confirmPasswordError">{{ confirmPasswordError }}</small>
                        </div>

                            <div class="erro" v-show="errorMessage">
                                <small>{{ errorMessage }}</small>
                            </div>

                            <div class="mb-4 text-center submit">
                                <button
                                    type="submit"
                                    class="btn-success weflix"
                                    :disabled="isLoading || !isFormValid"
                                >
                                    {{ isLoading ? 'Salvando...' : 'Definir senha' }}
                                </button>
                            </div>

                            <div class="text-center">
                                <router-link to="/admin" class="weflix back-link">Voltar ao login</router-link>
                            </div>
                        </template>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiPassword from '@/utils/password.js';
import { applySuperAdminBranding } from '@/utils/superAdmin/branding';

export default {
    name: 'SetPasswordSuperAdmin',
    data() {
        return {
            password: '',
            confirmPassword: '',
            passwordError: '',
            confirmPasswordError: '',
            errorMessage: '',
            showPassword: 'password',
            showConfirmPassword: 'password',
            isLoading: false,
            success: false,
            redirectTimer: null,
        };
    },
    computed: {
        token() {
            return this.$route.params.token || this.$route.query.token || '';
        },
        isFormValid() {
            return (
                this.token
                && this.password.length >= 8
                && this.password === this.confirmPassword
            );
        },
    },
    methods: {
        validatePassword() {
            this.passwordError = '';
            if (this.password.length > 0 && this.password.length < 8) {
                this.passwordError = 'A senha deve ter no mínimo 8 caracteres.';
            }
            if (this.confirmPassword) {
                this.validateConfirmPassword();
            }
        },
        validateConfirmPassword() {
            this.confirmPasswordError = '';
            if (this.confirmPassword && this.password !== this.confirmPassword) {
                this.confirmPasswordError = 'As senhas não coincidem.';
            }
        },
        async handleSubmit() {
            this.validatePassword();
            this.validateConfirmPassword();
            if (!this.token) {
                this.errorMessage = 'Link inválido. O token de definição de senha não foi encontrado.';
                return;
            }
            if (!this.isFormValid) {
                return;
            }

            this.isLoading = true;
            this.errorMessage = '';
            try {
                await apiPassword.changeSuperAdminPassword({
                    token: this.token,
                    password: this.password,
                });
                this.success = true;
                this.redirectTimer = setTimeout(() => {
                    this.$router.replace({ name: 'LoginSuperAdmin' });
                }, 2500);
            } catch (error) {
                const apiMessage = error?.response?.data?.message;
                this.errorMessage = apiMessage || 'Não foi possível definir a senha. O link pode ter expirado.';
            } finally {
                this.isLoading = false;
            }
        },
    },
    mounted() {
        applySuperAdminBranding();
        if (!this.token) {
            this.errorMessage = 'Link inválido. O token de definição de senha não foi encontrado.';
        }
    },
    beforeUnmount() {
        clearTimeout(this.redirectTimer);
    },
};
</script>

<style scoped>
.form {
    max-width: 100%;
    margin: 0 30px;
    text-align: left;
    height: auto;
    position: relative;
}
.form-title {
    margin: 0 0 6px;
    font-size: 22px;
    color: #160c31;
}
.form-subtitle {
    margin: 0 0 8px;
    color: #6c757d;
    font-size: 14px;
}
.login {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-image: url("@/assets/Weflix/bg-login-weflix.png");
    background-size: cover;
}
.content {
    width: 100%;
    margin: auto;
    padding: 32px 16px;
    box-sizing: border-box;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: clamp(40px, 5vh, 64px);
}
.logo {
    display: flex;
    justify-content: center;
    position: relative;
    top: auto;
    margin: 0;
    flex-shrink: 0;
}
.logo img {
    width: 200px;
    height: auto;
}
.info {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    flex-shrink: 0;
    width: min(450px, 100%);
    padding: 30px 10px;
    background-color: white;
    border-radius: 10px;
}
.mb-3 {
    margin: 16px 0;
}
.password-control {
    position: relative;
}
.form-control {
    width: 100%;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 10px 40px 10px 12px;
    line-height: 1.5;
}
.password-toggle {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 40px;
    transform: none;
    border: 0;
    border-radius: 0;
    background: transparent;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #adb5bd;
    cursor: pointer;
}
.password-toggle :deep(svg) {
    position: static !important;
    top: auto !important;
    right: auto !important;
    margin: 0;
    font-size: 15px;
    color: #adb5bd;
}
.field-error,
.erro small {
    color: #dc3545;
    display: block;
    margin-top: 6px;
}
.success {
    margin: 28px 0 8px;
    text-align: center;
}
.success-title {
    margin: 0 0 8px;
    color: #157347;
    font-size: 18px;
    font-weight: 700;
}
.success-text {
    margin: 0;
    color: #6c757d;
    font-size: 14px;
}
.submit {
    margin-top: 20px;
}
button.btn-success.weflix {
    background-color: #0d1a7e !important;
    width: 100%;
    color: white;
    padding: 10px;
    border-radius: 5px;
    border: none;
}
button.btn-success.weflix:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.back-link {
    color: #0d1a7e;
    font-size: 14px;
}
@media (max-width: 600px) {
    .info {
        width: 100%;
    }
    .form {
        margin: 0 16px;
    }
}
</style>
